import * as THREE from "three";

import Experience from "../Experience.js";
import Environment from "./Environment.js";
import AboutMiiHead from "./AboutMiiHead.js";
import HeroCrystals from "./HeroCrystals.js";

export default class World {
  constructor() {
    this.experience = new Experience();
    this.scene = this.experience.scene;
    this.resources = this.experience.resources;

    this.resources.on("ready", () => {
      this.environment = new Environment();
      this.heroCrystals = new HeroCrystals();
      this.aboutMiiHead = new AboutMiiHead();
    });
  }

  update() {
    if (this.aboutMiiHead) {
      this.aboutMiiHead.update();
    }
    if (this.heroCrystals) {
      this.heroCrystals.update();
    }
  }

  dispose() {
    if (this.environment?.dispose) {
      this.environment.dispose();
    }
    if (this.aboutMiiHead?.cleanup) {
      this.aboutMiiHead.cleanup();
    }
    if (this.heroCrystals?.dispose) {
      this.heroCrystals.dispose();
    }
  }
}
